export class Config {
public static API_URL = `${window.location.origin}/api-texte`;
  // public static API_URL = 'http://localhost:3000';

}
